import { getFullTabTitle } from './getFullTabTitle';

export const transformItemsToTabs = ({ items, type, zone, maxRecs, treatmentId, brand, userStatus, globalUniqueIds }) => {
  // A Map automatically remembers the order of insertion natively
  const tabsMap = new Map();

  for (const item of items) {
    const keyNameMap = {
      sale: { key: 'sale', tabName: 'Sale' },
      category: { key: item.categoryName, tabName: item.categoryName },
      brand: { key: item.brandName, tabName: item.brandName },
    };

    const { key, tabName } = keyNameMap[type] || {};

    // Skip if invalid or if product is already used in another tab
    if (!key || !tabName || !item.productId || globalUniqueIds.has(item.productId)) {
      continue;
    }

    // Mark product as used globally
    globalUniqueIds.add(item.productId);

    // Initialize tab in Map if it doesn't exist yet
    if (!tabsMap.has(key)) {
      tabsMap.set(key, { tabName, productIds: [] });
    }

    tabsMap.get(key).productIds.push(item.productId);
  }

  const choiceId = items[0]?.choiceId ? items[0]?.choiceId?.split('-')[0]?.replace(/^cid/, '') : 'no choice id';
  const headerText = items[0]?.choiceId ? decodeURIComponent(items[0]?.choiceId)?.split('@')[2]?.split('$')[0]?.replace(/\+/g, ' ') : '';

  return Array.from(tabsMap.values()).map((tabData, index) => ({
    zone,
    maxRecs,
    treatmentId,
    choiceId,
    headerText,
    panelType: 'zor',
    componentType: 'ProsCarousel',
    tabTitle: getFullTabTitle({ tabName: tabData.tabName, type, index, userStatus, brand }),
    productIds: tabData.productIds,
  }));
};
